import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import PasswordVisibility from "./PasswordVisibility";

const TextInput = React.forwardRef((props, ref) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const user_type = Digit.SessionStorage.get("userType");
  const [date, setDate] = useState();
  const data = props?.watch
    ? {
        fromDate: props?.watch("fromDate"),
        toDate: props?.watch("toDate"),
      }
    : {};

  const handleDate = (event) => {
    const { value } = event.target;
    setDate(getDDMMYYYY(value));
  };

  return (
    <React.Fragment>
      <div className={`text-input ${props.className}`} style={props?.textInputStyle ? { ...props.textInputStyle} : {}}>
        {props.isMandatory ? (
          <input
            type={props?.validation && props.ValidationRequired ? props?.validation?.type : props.type === 'password' && isPasswordVisible ? 'text' : (props.type || "text")}
            name={props.name}
            id={props.id}
            className={`${user_type ? "employee-card-input-error" : "card-input-error"} ${props.disable && "disabled"}`}
            placeholder={props.placeholder}
            onChange={(event) => {
              if (props?.onChange) {
                props?.onChange(event);
              }
              if (props.type === "date") {
                handleDate(event);
              }
            }}
            ref={props.inputRef || ref}
            value={props.value}
            style={{ ...props.style }}
            defaultValue={props.defaultValue}
            minLength={props.minlength}
            maxLength={props.maxlength}
            max={props.max}
            pattern={props?.validation && props.ValidationRequired ? props?.validation?.pattern : props.pattern}
            min={props.min}
            readOnly={props.disable}
            title={props?.validation && props.ValidationRequired ? props?.validation?.title :props.title}
            step={props.step}
            autoFocus={props.autoFocus}
            onBlur={props.onBlur}
            autoComplete={'off'}
            disabled={props.disabled}
          />
        ) : (
          <input
            type={props?.validation && props.ValidationRequired ? props?.validation?.type : props.type === 'password' && isPasswordVisible ? 'text' : (props.type || "text")}
            name={props.name}
            id={props.id}
            className={`${user_type ? "employee-card-input" : "citizen-card-input"} ${props.disable && "disabled"} focus-visible ${props.errorStyle && "employee-card-input-error"}`}
            placeholder={props.placeholder}
            onChange={(event) => {
              if (props?.onChange) {
                props?.onChange(event);
              }
              if (props.type === "date") {
                handleDate(event);
              }
            }}
            ref={props.inputRef || ref}
            value={props.value}
            style={{ ...props.style }}
            defaultValue={props.defaultValue}
            minLength={props.minlength}
            maxLength={props.maxlength}
            max={props.max}
            required={props?.validation && props.ValidationRequired ? props?.validation?.isRequired :props.isRequired || (props.type === "date" && (props.name === "fromDate" ? data.toDate : data.fromDate))}
            pattern={props?.validation && props.ValidationRequired ? props?.validation?.pattern : props.pattern}
            min={props.min}
            readOnly={props.disable}
            title={props?.validation && props.ValidationRequired ? props?.validation?.title :props.title}
            step={props.step}
            autoFocus={props.autoFocus}
            onBlur={props.onBlur}
            onKeyPress={props.onKeyPress}
            autoComplete={'off'}
            disabled={props.disabled}
          />
        )}
        {props.type === "date" && <DatePicker {...props} date={date} setDate={setDate} data={data} />}
        {props.type === "password" && <PasswordVisibility {...{ isPasswordVisible, setIsPasswordVisible }} />}
        {props.signature ? props.signatureImg : null}
      </div>
    </React.Fragment>
  );
});

TextInput.propTypes = {
  userType: PropTypes.string,
  isMandatory: PropTypes.bool,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  inputRef: PropTypes.func,
  value: PropTypes.any,
};

TextInput.defaultProps = {
  isMandatory: false,
};

function DatePicker(props) {
  useEffect(() => {
    if (props?.shouldUpdate) {
      props?.setDate(getDDMMYYYY(props?.data[props.name], "yyyymmdd"));
    }
  }, [props?.data]);

  useEffect(() => {
    props.setDate(getDDMMYYYY(props?.defaultValue));
  }, []);

  return (
    <input
      type="text"
      className={`${props.disable && "disabled"} card-date-input`}
      name={props.name}
      id={props.id}
      placeholder={props.placeholder}
      defaultValue={props.date}
      readOnly={true}
    />
  );
}

function getDDMMYYYY(date) {
  if (!date) return "";

  return new Date(date).toLocaleString("en-In").split(",")[0];
}

export default TextInput;
